import {
  SET_LOADING,
  SET_MEMBER,
  SET_MEMBER_TOTAL,
  SET_MEMBERS,
} from "./mutations";
import ApiService from "@/core/services/ApiService";

export default {
  async fetchMembers({ commit }, params = {}) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.query("backend/members", params)
      .then((result) => {
        result = result.data;
        commit(SET_MEMBERS, result?.data ?? []);
        commit(SET_MEMBER_TOTAL, result?.total ?? []);
        commit(SET_LOADING, false);

        return result;
      })
      .catch(({ response }) => {
        // console.log("error response", response);
      });
  },
  async fetchMember({ commit }, params) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.get("backend/members", params)
      .then((result) => {
        result = result.data;
        commit(SET_MEMBER, result ?? {});
        commit(SET_LOADING, false);
        return result;
      })
      .catch(({ response }) => {
        // console.log("error response", response);
        commit(SET_MEMBER, { success: false });
      });
  },
  async createMembers({ commit }, params) {
    commit(SET_LOADING, true, { root: true });
    ApiService.setHeader();
    return await ApiService.post("backend/members", params)
      .then((result) => {
        result = result.data;

        commit(SET_LOADING, false);

        return result;
      })
      .catch(({ response }) => {
        // console.log("error response", response.data);
        return response.data;
      });
  },
  async updateMembers({ commit }, params) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.put("backend/members/" + params.id, params)
      .then((result) => {
        result = result.data;

        return result;
      })
      .catch(({ response }) => {
        // console.log("error response", response.data);
        return response.data;
      });
  },

  async deleteMembers({ commit }, params) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.delete("backend/members/" + params)
      .then(async (result) => {})
      .catch((response) => {
        // console.log("delete error response", response);
      });
  },
};
